

export class XmlLog {

    private static readonly _prefix: string = 'IsiXml: ';
    private _userPrefix: string;
    private _uniqueId: string = "none";

    constructor(userPrefix: string) {
        this._userPrefix = userPrefix;
    }

    setId(uniqueId: string) {
        this._uniqueId = uniqueId;
    }

    log(s: string) {
        uiCore.log(XmlLog._prefix + ' [' + this._uniqueId + ']' + this._userPrefix + ' ' + s);
    }
}

